(ns app.strive-forms.helper-functions
  (:require [app.strive-forms.defaults :refer [default-values]]
            [clojure.string :refer [includes? replace split] :as s]
            [hickory.core :refer [as-hiccup parse-fragment]]
            [hickory.render :refer [hiccup-to-html]]
            [re-frame.core :as re-frame]
            [app.strive-forms.events :as sfevents]))

(defn remove-parentheses-from-string [regex]
  (replace (replace (first (re-find #"\{\{\{([^)]+)\}\}\}" regex)) #"\{" "") #"\}" ""))

(defn remove-quotaion-from-string [value]
  (replace value #"\"" ""))

(defn split-string-with-comma [value]
  (split value #","))

(defn span-includes-hidden-filds? [regex]
  (includes?
   (last
    (split-string-with-comma (remove-parentheses-from-string  regex))) "hidden_field"))

(defn get-id-value-from-string [regex]
  (last (split
         (remove-quotaion-from-string
          (first
           (split-string-with-comma (remove-parentheses-from-string  regex)))) #":")))

(defn get-question-title-in-html [field hidden-fields display-fields selected-language input-data]
  (hiccup-to-html
   (reduce
    (fn [field-value hiccup]
      (conj field-value
            (reduce
             (fn [result value]
               (if (some? (:data-marker (get value 1)))
                 (if (span-includes-hidden-filds? (:data-marker (get value 1)))
                   (conj result (or (get hidden-fields (keyword (get-id-value-from-string (:data-marker (get value 1))))) ""))
                   (conj result
                         (if (some? (:value (get input-data (keyword (get-id-value-from-string (:data-marker (get value 1)))))))
                           (str (:value (get input-data (keyword (get-id-value-from-string (:data-marker (get value 1)))))))
                           ((keyword selected-language)
                            (:field_name_html
                             (first (filter (fn [x]
                                              (=  (get-id-value-from-string (:data-marker (get value 1)))
                                                  (:id x)))
                                            display-fields)))))))

                 (if (= (get value 0) :strong)
                   (conj result (reduce (fn [strong-result strong-value]
                                          (if (some? (:data-marker (get strong-value 1)))
                                            (if (span-includes-hidden-filds? (:data-marker (get strong-value 1)))
                                              (conj strong-result (or (get hidden-fields (keyword (get-id-value-from-string (:data-marker (get strong-value 1))))) ""))
                                              (conj strong-result ((keyword selected-language)
                                                                   (:field_name_html
                                                                    (first
                                                                     (filter (fn [x]
                                                                               (=  (get-id-value-from-string (:data-marker (get strong-value 1)))
                                                                                   (:id x)))
                                                                             display-fields))))))
                                            (conj strong-result strong-value)))
                                        []
                                        value))
                   (conj result value))))
             []
             hiccup)))
    []
    (map as-hiccup (parse-fragment field)))))

(defn get-font-for-multi-question-page-title [{:keys [title-multiplied-by]}]
  (* title-multiplied-by (double (:font-size (:title default-values)))))

(defn get-question-description [field selected-language]
  (if (and (some? (:description_obj field)) (some? ((keyword selected-language) (:description_obj field))))
    ((keyword selected-language) (:description_obj field))
    (if (some? (:description field))
      (:description field) "")))

(defn get-theme-color [{:keys [theme-color default-color]}]
  (if (nil? theme-color)
    default-color
    theme-color))

(defn color-condition [{:keys [valid? on-focus theme-data default-color is-label?]}]
  (cond
    (and valid? (not on-focus)) (get-theme-color {:theme-color (:answers_border_color theme-data)
                                                  :default-color default-color})
    (and valid? on-focus) (:buttons_color theme-data (:primary (:themes default-values)))
    (and (not is-label?) (not valid?)) (:error (:themes default-values))))

(defn get-border-color [{:keys [answer-color answers-border-color buttons-color text-val value]}]
  (if (and (nil? answer-color) (= @text-val value))
    buttons-color
    (or answer-color (str answers-border-color "60"))))

(defn on-focus-toggle [on-focus]
  #(swap! on-focus not))

(defn check-question-visibility [{:keys [index current-page visible?]}]
  (if (not= index @current-page) (reset! visible? false) (reset! visible? true)))

;TODO: unit testing
(defn generate-alphabet [length]
  (let [letter-a 97]
    (->> (range length)
         (map (fn [index]
                (-> (+ index letter-a) char))))))

(defn component-alignment [is-multi-question?]
  (if is-multi-question? :start :center))

(defn required-validation [text-val is-required]
  (and (s/blank? text-val) (not is-required)))

(defn required-and-empty? [{:keys [text-val field valid?]}]
  (when (required-validation @text-val (:is_required field)) (reset! valid? true)))

(defn read-json [parsed-array]
  (map (fn [item]
         (js->clj (.parse js/JSON item)  :keywordize-keys true)) parsed-array))

(defn split-string [default-value]
  (if (and (= (first default-value) "@") (some? default-value))
    (s/split (subs default-value 1)  " @")
    nil))

(defn extract-keys-if-hidden [default-value-map]
  (let [types-of-def-value (map #(keyword (get % :type)) default-value-map)
        keys-of-def-value (map #(keyword (get % :key)) default-value-map)]
    (map-indexed (fn [idx item]
                   (when (= item :hidden) (nth keys-of-def-value idx))) types-of-def-value)))

(defn extract-from-hidden-fields [values-of-hidden-keys]
  (if (not (s/blank? (s/join " " values-of-hidden-keys)))
    (s/join " " values-of-hidden-keys)
    nil))

(defn parse-default-value [default-value]
  (-> (split-string default-value)
      (read-json)))

(defn get-default-value [{:keys [default-value hidden-fields]}]
  (let [default-value-map (parse-default-value default-value)
        hidden-keys (when-not (empty? default-value-map) (extract-keys-if-hidden default-value-map))
        values-of-hidden-keys (mapv (fn [item]
                                      (when (contains? hidden-fields item) (get hidden-fields item))) hidden-keys)
        default-value-from-hidden-fields (extract-from-hidden-fields values-of-hidden-keys)]
    (cond
      (= (first default-value) "@") default-value-from-hidden-fields
      :else default-value)))

(defn get-default-text-val [{:keys [field-id input-data default-value type current-page index num-scale-initial? default-date]}]
  (let [user-input-value? (some? (:value (get input-data (keyword field-id))))
        user-input-value (:value (get input-data (keyword field-id)))
        in-correct-page? (= current-page index)]
    (cond
      (= type :boolean) (if user-input-value?
                          user-input-value
                          (or (when (= default-value "Yes") "1") (when (= default-value "No") "0")))
      (= type :date) (if user-input-value?
                          user-input-value
                          (when in-correct-page? default-date))
      (= type :legal_statement) (if user-input-value?
                          user-input-value
                          (or (when (= default-value "Approve") "1") (when (= default-value "Disapprove") "0")))
      :else (if (and (false? num-scale-initial?) user-input-value?)
              user-input-value
              (when in-correct-page? default-value)))))

(defn handle-scroll-event [{:keys [event scrolled?]}]
  (let [pixels-scrolled (.-scrollTop event.target)]
    (when (> pixels-scrolled 45)
      (reset! scrolled? true))
    (when (< pixels-scrolled 45)
      (reset! scrolled? false))))


(defn smooth-scroll-with-timeout [{:keys [item end-of-page]}]
  (let [scroll-options (clj->js {:top (if end-of-page 1000 (:scroll-down-pixels default-values)) :behavior "smooth"})]
    (js/setTimeout #(.scrollBy item scroll-options) 400)))

(defn scroll-down-page! [{:keys [page-num end-of-page]}]
  (let [elements (first (.getElementsByClassName js/document "react-swipeable-view-container"))
        children-element (.-children elements)]
    (smooth-scroll-with-timeout {:item (.item children-element page-num) :end-of-page end-of-page})))

(defn- scroll-down? [{:keys [event bottom-percentage-of-page]}]
  (let [viewport-height (.-innerHeight js/window)
        threshold (* viewport-height (- 1.0 bottom-percentage-of-page))]
    (> (.-clientY event) threshold)))

(defn maybe-scroll-down! [{:keys [event index bottom-percentage-of-page]}]
  (when (scroll-down? {:event event :bottom-percentage-of-page bottom-percentage-of-page})
    (scroll-down-page! {:page-num index :end-of-page false})))

(defn update-preview-panel! [{:keys [input-data field-id value-to-update condition]}]
  (when (and (s/blank? (:value (get input-data (keyword field-id)))) condition)
    (re-frame/dispatch [::sfevents/update-input-local
                        {:input-data input-data :key (keyword field-id) :value value-to-update}])))


(defn get-button-label [{:keys [form-messages field-type next-page?]}]
  (if (= field-type "welcome_screen")
    (:start_button_text form-messages (:start_button_text default-values))
    (if next-page?
      (:continue_button_text form-messages (:continue_button_text default-values))
      (:submit_button_text form-messages (:submit_button_text default-values)))))

(defn enable-continue-button [{:keys [button-ids-for-button field-id]}]
  (while (contains? @button-ids-for-button field-id)
    (reset! button-ids-for-button (disj @button-ids-for-button field-id))))

(defn disable-continue-button [{:keys [button-ids-for-button field-id]}]
  (while (not (contains? @button-ids-for-button field-id))
    (reset! button-ids-for-button (conj @button-ids-for-button field-id))))

(defn check-button-status [{:keys [component-button-disabled? button-ids-for-button field-id]}]
  (add-watch component-button-disabled? :watcher
             (fn []
               (if (false? @component-button-disabled?)
                 (enable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)})
                 (disable-continue-button {:button-ids-for-button button-ids-for-button :field-id (keyword field-id)})))))

(defn set-values-for-button! [{:keys [field-id component-input-value input-value type]}]
  (if (some #(= (:id %) field-id) @input-value)
    (swap! input-value #(mapv (fn [x]
                                (update x :input-value (fn [value]
                                                         (if (= (:id x) field-id)
                                                           @component-input-value
                                                           value))))
                              @input-value))
    (swap! input-value conj {:id field-id
                             :type type
                             :input-value @component-input-value})))

(defn get-error-message-color [new-session]
  (if @new-session "black" (:error-mesage (:themes default-values))))

(defn get-required-message [{:keys [form-messages]}]
  (:required_text form-messages (:required_text default-values)))

(defn scroll-to-next-required-field! [{:keys [missing-required-fields field-id current-page is-multi-question? steps-total]}]

  (if (> (count @missing-required-fields) 1)
    (do
      (reset! missing-required-fields (remove (fn [x]
                                                (= (:field-id x) field-id))
                                              @missing-required-fields))
      (reset! current-page (:page-num (first @missing-required-fields)))
      ;;when-let
      (when (and is-multi-question? (.getElementById js/document (str "question-field-area-" (:field-id (first @missing-required-fields)))))
        (.scrollIntoView (.getElementById js/document (str "question-field-area-" (:field-id (first @missing-required-fields))))
                         (clj->js {:block "center" :inline "center" :behavior "auto"}))))
    (do (reset! missing-required-fields (remove (fn [x]
                                                  (= (:field-id x) field-id))
                                                @missing-required-fields))
        (reset! current-page (dec @steps-total))
        (scroll-down-page! {:page-num (dec @steps-total) :end-of-page true}))))

(defn process-response-all-fields! [{:keys [input-data field-id regenerate-display-fields input-value]}]
  (re-frame/dispatch [::sfevents/update-input-local
                      {:input-data input-data :key (keyword field-id) :value input-value}])
  (regenerate-display-fields
   (update input-data (keyword field-id) (fn [value]
                                           (assoc value
                                                  :value input-value)))))

(defn save-value-on-last-page [{:keys [final-page? input-data field-id regenerate-display-fields text-val]}]
  (when final-page? (process-response-all-fields! {:input-data input-data :field-id field-id
                                                   :regenerate-display-fields regenerate-display-fields
                                                   :input-value @text-val})))

(defn submit-if-final-question [{:keys [final-page? input-data on-submit]}] 
  (when final-page?
    (on-submit input-data)))